import React from "react";
import {
  Button,
  Card,
  Col,
  Collapse,
  Descriptions,
  Divider,
  Form,
  Icon,
  Popconfirm,
  Row,
  Spin,
  Table,
  Tooltip
} from 'antd';
import LeasedAssets from './lease';
import Suspend from "./suspend";
import moment from 'moment';
import AccessControl from "../../components/AccessControl";
import LeaseAmount from "./amount";
import AssetName from "./Asset";
import FieldEdit from "./field_edit";
import DocumentList from "../../components/DocumentList";

const {Panel} = Collapse;

class View extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      documentData: [],
      suspendedDocumentData: [],
      addAssetShow: false,
      addDocumentShow: false,
      addSuspendShow: false,
      addAmountShow: false,
      selectedContract: null,
      selectedAssetRecord: null,
      suspenseRecordForEdit: null,
      amountRecordForEdit: null,
      editShow: false,
      editObj: null,
    };
  }

  componentDidMount() {
    const {match, fetch} = this.props;
    if(match.params && match.params.id) {
      fetch(match.params.id);
      this.props.getLocations();
    }
  }

  getDocumentData = (data) => {
    // console.log(this.props.match.params.id, data[0]);
    this.setState({documentData: data});
    if(this.props.match.params.id && data && data.length > 0)
      this.props.uploadDoc(this.props.match.params.id, data[0]);
  };

  getSuspendedDocumentData = (data) => {
    this.setState({suspendedDocumentData: data})
  };

  editShowToggle = (field, label, value, contract, asset, type) => {
    const isShow = this.state.editShow;
    this.setState({
      editShow: !isShow,
      editObj: {field, label, value, contract, asset, type}
    })
  }

  addAssetShowToggle = (contractId) => {
    this.setState({
      addAssetShow: !this.state.addAssetShow,
    })
  }

  addSuspendShowToggle = (contractId, assetRecordId, suspenseRecordId, remove) => {
    if(remove && remove === 'remove') {
      this.props.suspendRecord(contractId, assetRecordId, 'remove',
        {
          id: suspenseRecordId
        }
      );

    } else {
      const isShow = this.state.addSuspendShow;
      this.setState({
        addSuspendShow: !isShow,
        selectedContract: !isShow ? contractId : null,
        selectedAssetRecord: !isShow ? assetRecordId : null,
        suspenseRecordForEdit: !isShow ? suspenseRecordId : null,
      })
    }
  };

  addDocumentsShowToggle = (contractId) => {
    this.setState({
      addDocumentShow: !this.state.addDocumentShow,
    })
  };

  addAmountShowToggle = (contractId, assetRecordId, amountRecordId, remove) => {
    // console.log(remove);
    if(remove && remove === 'remove') {

      this.props.updateAssets(contractId, assetRecordId, 'remove',
        {
          leaseAmount: {
            id: amountRecordId
          }
        }
      );
    } else {
      const isShow = this.state.addAmountShow;
      this.setState({
        addAmountShow: !isShow,
        selectedContract: !isShow ? contractId : null,
        selectedAssetRecord: !isShow ? assetRecordId : null,
        amountRecordForEdit: !isShow ? amountRecordId : null,
      })
    }
  }

  getLocation = (locationId) => {
    if(locationId && this.props.locations && this.props.locations.length > 0) {
      const locObj = this.props.locations.filter(doc => doc._id.toString() === locationId.toString());
      return locObj && locObj[0] && locObj[0]['name'];
    }
  }

  getAssetPeriod = (data) => {
    if(data && data.assets && data.assets.length > 0) {
      return data.assets.map((asset, index) => (
        <Col span={24} key={index}>
          <Card key={index} size="small" extra={data.assets.length > 1 ? (
            <AccessControl resource={this.props.resourceName} permissionNeeded={'d'}
                           roles={this.props.authUser ? this.props.authUser.roles : []}
                           render={(props) => {
                             return <Popconfirm
                               title="Are you sure delete this record ?"
                               onConfirm={() => {
                                 this.props.updateAssets(data._id, asset.id, 'remove', {asset: {id: asset.id}});
                               }}
                               okText="Yes"
                               cancelText="No"
                             ><Tooltip title="Remove this asset"><Icon
                               type="delete"
                               theme="twoTone" twoToneColor="#eb2f96"
                             />&nbsp;&nbsp;</Tooltip>
                             </Popconfirm>
                           }}/>) : null}>
            <Descriptions
              column={2}
              bordered
              key={index}
            >
              <Descriptions.Item label="Asset">{<AssetName
                asset={asset && asset.leasingAsset} {...this.props}/>}</Descriptions.Item>
              <Descriptions.Item
                label="Location">{this.getLocation(asset.location)}</Descriptions.Item>
              <Descriptions.Item
                label="Period From">
                {asset && asset.periodFrom && moment(asset.periodFrom).format("DD/MM/YYYY")}
                <AccessControl resource={this.props.resourceName} permissionNeeded={'u'}
                               roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
                  return <Tooltip title="Edit this field">
                    <Icon style={{float: 'right', fontSize: '100%'}}
                          type="edit" theme="twoTone" twoToneColor="#eb2f96"
                          onClick={() => this.editShowToggle('periodFrom', 'Period From', asset.periodFrom, data._id, asset.id, 'date')}/>
                  </Tooltip>
                }}/>
              </Descriptions.Item>
              <Descriptions.Item
                label="Period To">
                {asset && asset.periodTo && moment(asset.periodTo).format("DD/MM/YYYY")}
                <AccessControl resource={this.props.resourceName} permissionNeeded={'u'}
                               roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
                  return <Tooltip title="Edit this field">
                    <Icon style={{float: 'right', fontSize: '100%'}}
                          type="edit" theme="twoTone" twoToneColor="#eb2f96"
                          onClick={() => this.editShowToggle('periodTo', 'Period To', asset.periodTo, data._id, asset.id, 'date')}/>
                  </Tooltip>
                }}/>
              </Descriptions.Item>
              <Descriptions.Item
                label="Lock-In From">
                {asset && asset.lockInPeriodFrom && moment(asset.lockInPeriodFrom).format("DD/MM/YYYY")}
                <AccessControl resource={this.props.resourceName} permissionNeeded={'u'}
                               roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
                  return <Tooltip title="Edit this field">
                    <Icon style={{float: 'right', fontSize: '100%'}}
                          type="edit" theme="twoTone" twoToneColor="#eb2f96"
                          onClick={() => this.editShowToggle('lockInPeriodFrom', 'LockIn Period From', asset.lockInPeriodFrom, data._id, asset.id, 'date')}/>
                  </Tooltip>
                }}/>
              </Descriptions.Item>
              <Descriptions.Item
                label="Lock-In To">
                {asset && asset.lockInPeriodTo && moment(asset.lockInPeriodTo).format("DD/MM/YYYY")}
                <AccessControl resource={this.props.resourceName} permissionNeeded={'u'}
                               roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
                  return <Tooltip title="Edit this field">
                    <Icon style={{float: 'right', fontSize: '100%'}}
                          type="edit" theme="twoTone" twoToneColor="#eb2f96"
                          onClick={() => this.editShowToggle('lockInPeriodTo', 'LockIn Period To', asset.lockInPeriodTo, data._id, asset.id, 'date')}/>
                  </Tooltip>
                }}/>
              </Descriptions.Item>
              <Descriptions.Item
                label="Residual Amount"
                span={2}>
                {(asset && asset.residualAmount) ? asset.residualAmount : '0'}
                <AccessControl resource={this.props.resourceName} permissionNeeded={'u'}
                               roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
                  return <Tooltip title="Edit this field">
                    <Icon style={{float: 'right', fontSize: '100%'}}
                          type="edit" theme="twoTone" twoToneColor="#eb2f96"
                          onClick={() => this.editShowToggle('residualAmount', 'Residual Amount', asset.residualAmount, data._id, asset.id, 'numeric')}/>
                  </Tooltip>
                }}/>
              </Descriptions.Item>
            </Descriptions>

            {this.getAssetAmount(asset)}
            {this.getAssetSuspendInfo(asset)}

          </Card>
        </Col>
      ))
    }
  }

  getAssetAmount = (data) =>
    (<Collapse>
      <Panel header={data && data.leaseAmount && data.leaseAmount.length + ' Amounts'} extra={(
        <AccessControl resource={this.props.resourceName} permissionNeeded={'u'}
                       roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
          return <Tooltip title="Add More Amount">
            <Icon style={{color: '#038fde', fontSize: '150%'}}
                  type="plus-circle"
                  onClick={() => this.addAmountShowToggle(this.props.data._id, data.id)}/>
          </Tooltip>
        }}/>)}>{
        data && data.leaseAmount && data.leaseAmount.length > 0 ?
          data.leaseAmount.map((amt, index) => (
            <div key={index}>
              <Descriptions
                column={2}
                bordered
                key={index}
              >
                <Descriptions.Item
                  label={'WEF'}>{amt && amt.wef && moment(amt.wef).format("DD/MM/YYYY")}</Descriptions.Item>
                <Descriptions.Item label={'Amount'}>{amt && amt.amount}</Descriptions.Item>
              </Descriptions>

              {/*// -------*/}
              <Descriptions bordered key={index + '-amt-wef'}>
                <Descriptions.Item label={(<div>
                  <AccessControl resource={this.props.resourceName} permissionNeeded={'u'}
                                 roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
                    return <Tooltip title="Edit this Amount record"><Icon
                      style={{fontSize: '100%'}}
                      theme="twoTone" twoToneColor="#eb2f96"
                      type="edit"
                      onClick={() => this.addAmountShowToggle(this.props.data._id, data.id, amt.id)}/></Tooltip>
                  }}/>&nbsp;&nbsp;
                  <AccessControl resource={this.props.resourceName} permissionNeeded={'d'}
                                 roles={this.props.authUser ? this.props.authUser.roles : []}
                                 render={(props) => {
                                   return <Popconfirm
                                     title="Are you sure delete this record ?"
                                     onConfirm={() => {
                                       this.addAmountShowToggle(this.props.data._id, data.id, amt.id, 'remove');
                                     }}
                                     okText="Yes"
                                     cancelText="No"
                                   ><Tooltip title="Remove this Amount record"><Icon
                                     style={{fontSize: '100%'}}
                                     theme="twoTone" twoToneColor="#eb2f96"
                                     type="delete"
                                   />
                                   </Tooltip>
                                   </Popconfirm>
                                 }}/></div>)}>
                </Descriptions.Item>
              </Descriptions>
            </div>

            // --------
          ))
          : null
      }
      </Panel>
    </Collapse>);

  removeDoc = (contract, docId) => {
    this.props.removeDoc(contract, docId);
  };

  getDocuments = (data) => {
    const documentColumns = [
      {title: 'Name', dataIndex: 'name', key: 'name'},
      {
        title: 'Type', dataIndex: 'type', key: 'type',
        render: (type) => <div>{type && type.name}</div>
      },
      {
        title: 'Renewal Date', dataIndex: 'renewalDate', key: 'renewalDate',
        render: (renewalDate) => <div>{renewalDate ? moment(renewalDate).format('DD-MM-YYYY') : "None"}</div>
      },
      {
        title: 'Document Date', dataIndex: 'documentDate', key: 'documentDate',
        render: (documentDate) => <div>{documentDate ? moment(documentDate).format('DD-MM-YYYY') : "None"}</div>
      },
      {
        title: 'Link to Document',
        key: 'href',
        render: (record) => {
          return (
            <a href={record.file && record.file.path} target="_blank">
            <span className="documentButton">
              Open Document
            </span>
            </a>
          );
        }
      },
      {
        title: '',
        key: 'remove',
        render: (record) => {
          return (
            <Popconfirm
              title="Are you sure delete this document?"
              onConfirm={() => this.removeDoc(data._id, record._id)}
              onCancel={null}
              okText="Yes"
              cancelText="No"
            >
              <Button type="danger" title={'Delete this document'}
                      size={'small'}>
                <Icon type="delete"/>
                Delete
              </Button>
            </Popconfirm>
          )
        }
      },];
    return (<Collapse defaultActiveKey={['doc1']}>
      <Panel header={`${data && data.documents ? data.documents.length : 0} contract documents`} key={'doc1'}
        /*extra={(
          <AccessControl resource={this.props.resourceName} permissionNeeded={'u'}
                         roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
            return <Tooltip title="Add More Document"><Icon style={{color: '#038fde', fontSize: '150%'}}
                                                            type="plus-circle"
                                                            onClick={() => this.addDocumentsShowToggle(this.props.data._id)}/></Tooltip>
          }}/>)}*/>
        <Descriptions layout="horizontal">
          <Descriptions.Item>
            {
              (data.documents && data.documents.length > 0 &&
                <Table dataSource={data.documents || []} columns={documentColumns || []}
                       pagination={false}
                       rowKey={(record) =>
                         record.name +
                         (record.type && record.type._id) +
                         record.documentDate
                       }/>) || "No documents found!"}

            {/*(data.documents || []).map((item, index) => {*/}
            {/*if(item.file) {*/}
            {/*return (*/}
            {/*<Popover key={index} title={null}*/}
            {/*content={<a onClick={() => this.removeDoc(data._id, item._id)}><Icon*/}
            {/*style={{fontSize: '100%'}}*/}
            {/*theme="twoTone" twoToneColor="#eb2f96"*/}
            {/*type="delete"*/}
            {/*/></a>}>*/}
            {/*<Button key={index} type="link" onClick={() => this.openInNewTab(item.file.path)}>*/}
            {/*<Icon type="file-search" style={{color: 'tomato', fontSize: '250%'}}/>*/}
            {/*</Button></Popover>)*/}
            {/*}*/}
            {/*}*/}
            {/*)*/}
            {/*}*/}
          </Descriptions.Item>
        </Descriptions>
      </Panel>
    </Collapse>)
  };

  getAssetSuspendInfo = (data) => {
    if(data && data.suspensionInfo && data.suspensionInfo.length > 0) {
      data.suspensionInfo.sort((a, b) => {
        return moment(a.suspensionFrom).get() - moment(b.suspensionFrom).get();
      });
    }
    return (
      <Collapse>
        <Panel header={data && data.suspensionInfo && data.suspensionInfo.length + ' Suspension Record/s'}
               extra={(
                 <AccessControl resource={this.props.resourceName} permissionNeeded={'u'}
                                roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
                   return <Tooltip title="Add More Suspension record"><Icon style={{color: '#038fde', fontSize: '150%'}}
                                                                            type="plus-circle"
                                                                            onClick={() => this.addSuspendShowToggle(this.props.data._id, data.id)}/></Tooltip>
                 }}/>)}>
          {
            (data && data.suspensionInfo && data.suspensionInfo.length > 0) ?
              data.suspensionInfo.map((asset, index) => (
                <div key={index}>
                  <Descriptions column={2}
                                bordered
                                key={index}>
                    <Descriptions.Item label={<span
                      className={'label-heading'}>From</span>}>{asset && asset.suspensionFrom && moment(asset.suspensionFrom).format("DD/MM/YYYY")}</Descriptions.Item>
                    <Descriptions.Item label={<span
                      className={'label-heading'}>To</span>}>{asset && asset.suspensionTo && moment(asset.suspensionTo).format("DD/MM/YYYY")}</Descriptions.Item>
                    <Descriptions.Item span={2} label={<span
                      className={'label-heading'}>Description</span>}>{asset && asset.suspensionDescription}</Descriptions.Item>
                  </Descriptions>
                  <Descriptions bordered key={index + '-doc'}>
                    <Descriptions.Item label={(<div>
                      <AccessControl resource={this.props.resourceName} permissionNeeded={'u'}
                                     roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
                        return <Tooltip title="Edit this Suspension record"><Icon
                          style={{fontSize: '100%'}}
                          theme="twoTone" twoToneColor="#eb2f96"
                          type="edit"
                          onClick={() => this.addSuspendShowToggle(this.props.data._id, data.id, asset.id)}/></Tooltip>
                      }}/>&nbsp;&nbsp;<AccessControl resource={this.props.resourceName} permissionNeeded={'d'}
                                                     roles={this.props.authUser ? this.props.authUser.roles : []}
                                                     render={(props) => {
                                                       return <Popconfirm
                                                         title="Are you sure delete this record ?"
                                                         onConfirm={() => {
                                                           this.addSuspendShowToggle(this.props.data._id, data.id, asset.id, 'remove');
                                                         }}
                                                         okText="Yes"
                                                         cancelText="No"
                                                       ><Tooltip title="Remove this Suspension record"><Icon
                                                         style={{fontSize: '100%'}}
                                                         theme="twoTone" twoToneColor="#eb2f96"
                                                         type="delete"
                                                       />
                                                       </Tooltip>
                                                       </Popconfirm>
                                                     }}/></div>)}>
                      {
                        asset.suspensionDocuments.map((item, index) => {
                          return (
                            <Button key={index} type="link" onClick={() => this.props.url(item)}>
                              <Icon type="file-search" style={{color: 'tomato', fontSize: '150%'}}/>
                            </Button>)
                        })
                      }
                    </Descriptions.Item>
                  </Descriptions>
                  <Divider/>
                </div>
              )) : null
          } </Panel></Collapse>)
  }


  openInNewTab = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if(newWindow) newWindow.opener = null
  }

  handleContractView = (id) => {
    // const {match} = this.props;
    this.props.history.push(`/contract/view/${id}`);
  }

  render() {
    const {data, loading, filters, title, resource, subDocumentFilters, form} = this.props;

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title}`}>

          <Descriptions column={2} bordered>
            <Descriptions.Item
              label="Id">{data && data.id}</Descriptions.Item>
            <Descriptions.Item label="Agreement Date">
              <div>
                {data && data.agreementDate && moment(data.agreementDate).format("DD/MM/YYYY")}
                <AccessControl resource={this.props.resourceName} permissionNeeded={'u'}
                               roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
                  return <Tooltip title="Edit this field">
                    <Icon style={{float: 'right', fontSize: '100%'}}
                          type="edit" theme="twoTone" twoToneColor="#eb2f96"
                          onClick={() => this.editShowToggle('agreementDate', 'Agreement Date', data.agreementDate, data._id, null, 'date')}/>
                  </Tooltip>
                }}/>

              </div>
            </Descriptions.Item>
            <Descriptions.Item label="Vendor" span={2}>
              {data && data.vendor && data.vendor.name}, {data && data.vendor && data.vendor.city}
            </Descriptions.Item>
            <Descriptions.Item label="Agreement From">
              <div>
                {data && data.agreementPeriodFrom && moment(data.agreementPeriodFrom).format("DD/MM/YYYY")}
                <AccessControl resource={this.props.resourceName} permissionNeeded={'u'}
                               roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
                  return <Tooltip title="Edit this field">
                    <Icon style={{float: 'right', fontSize: '100%'}}
                          type="edit" theme="twoTone" twoToneColor="#eb2f96"
                          onClick={() => this.editShowToggle('agreementPeriodFrom', 'Agreement From', data.agreementPeriodFrom, data._id, null, 'date')}/>
                  </Tooltip>
                }}/>
              </div>
            </Descriptions.Item>
            <Descriptions.Item
              label="Agreement To">
              {data && data.agreementPeriodTo && moment(data.agreementPeriodTo).format("DD/MM/YYYY")}
              <AccessControl resource={this.props.resourceName} permissionNeeded={'u'}
                             roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
                return <Tooltip title="Edit this field">
                  <Icon style={{float: 'right', fontSize: '100%'}}
                        type="edit" theme="twoTone" twoToneColor="#eb2f96"
                        onClick={() => this.editShowToggle('agreementPeriodTo', 'Agreement To', data.agreementPeriodTo, data._id, null, 'date')}/>
                </Tooltip>
              }}/>
            </Descriptions.Item>
            <Descriptions.Item
              label="Prev Contract">{data && data.prevContract && data.prevContract._id && (<Button type={'link'}
                                                                                                    onClick={() => this.openInNewTab('/contract/view/' + data.prevContract._id)}>{data.prevContract.id}</Button>)}</Descriptions.Item>
            <Descriptions.Item
              label="Next Contract">{data && data.nextContract && data.nextContract._id && (<Button type={'link'}
                                                                                                    onClick={() => this.openInNewTab('/contract/view/' + data.nextContract._id)}>{data.nextContract.id}</Button>)}</Descriptions.Item>
          </Descriptions>

          <Divider/>
          <Collapse>
            <Panel header={data && data.assets && data.assets.length + ' Assets'} extra={(
              <AccessControl resource={this.props.resourceName} permissionNeeded={'u'}
                             roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
                return <Tooltip title="Add More Asset"><Icon style={{color: '#038fde', fontSize: '150%'}}
                                                             type="plus-circle"
                                                             onClick={() => this.addAssetShowToggle(this.props.data._id)}/></Tooltip>
              }}/>)}>
              <Row>
                {
                  this.getAssetPeriod(data)
                }
              </Row>
            </Panel>
          </Collapse>

          <LeasedAssets list={data.assetLeasePeriod} visible={this.state.addAssetShow}
                        showToggle={this.addAssetShowToggle} {...this.props} />


          <Divider/>
          {
            this.getDocuments(data)
          }
          <AccessControl resource={this.props.resourceName} permissionNeeded={'u'}
                         roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
            return (
              <DocumentList history={this.props.history}
                            match={this.props.match}
                            key={'documents'}
                            item={filters['documents']}
                            form={form}
                            comeFrom={'jobCardReport'}
                            getDocumentData={this.getDocumentData}
              />)
          }}/>

          {/*{this.state.addDocumentShow ? <ContractDocument visible={this.state.addDocumentShow}*/}
          {/*contract={this.props.match && this.props.match.params && this.props.match.params.id}*/}
          {/*showToggle={this.addDocumentsShowToggle} {...this.props} /> : null}*/}


          {this.state.addSuspendShow ?
            <Suspend list={data.assets} {...this.props} visible={this.state.addSuspendShow}
                     showToggle={this.addSuspendShowToggle} contract={this.state.selectedContract}
                     assetRecord={this.state.selectedAssetRecord} suspenseRecord={this.state.suspenseRecordForEdit}/>
            : null}
          {this.state.addAmountShow ?
            <LeaseAmount list={data.assetLeasePeriod} {...this.props} visible={this.state.addAmountShow}
                         showToggle={this.addAmountShowToggle} contract={this.state.selectedContract}
                         assetRecord={this.state.selectedAssetRecord}
                         amountCurrentRecord={this.state.amountRecordForEdit}/>
            : null}
          {this.state.editShow ?
            <FieldEdit list={data.assetLeasePeriod} {...this.props} visible={this.state.editShow}
                       showToggle={this.editShowToggle} fileObj={this.state.editObj}/>
            : null}

        </Card>
      </Spin>
    );
  }
}

const ViewForm = Form.create
({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(View);

export default ViewForm;
